import React from 'react';

const AddictionImpact = ({ addictions = [] }) => {
  console.log('🎯 AddictionImpact component received props:', { addictions, addictionsLength: addictions.length });
  
  if (!addictions || addictions.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-md p-6">
        <h3 className="text-lg font-semibold mb-4">Addiction Impact</h3>
        <div className="text-center text-gray-500">
          <div className="text-gray-400 text-lg mb-2">🎯</div>
          <p>No addiction data available</p>
          <p className="text-sm text-gray-400 mt-1">Complete your questionnaire to see addiction impact analysis</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-semibold mb-4">Addiction Impact</h3>
      
      {/* Addiction Cards */}
      <div className="space-y-4">
        {addictions.map((addiction, index) => (
          <div key={index} className="border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <h5 className="font-medium text-gray-900 capitalize">{addiction.type}</h5>
              <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                addiction.impact_level === 'high' ? 'bg-red-100 text-red-800' :
                addiction.impact_level === 'medium' ? 'bg-yellow-100 text-yellow-800' :
                addiction.impact_level === 'low' ? 'bg-green-100 text-green-800' :
                'bg-gray-100 text-gray-800'
              }`}>
                {addiction.severity} severity
              </span>
            </div>
            
            <div className="space-y-2">
              <div className="text-sm text-gray-600">
                <span className="font-medium">Frequency:</span> {addiction.frequency}
              </div>
              
              <div className="text-sm text-gray-600">
                <span className="font-medium">Impact:</span> {addiction.impact_level}
              </div>
              
              {addiction.lifestyle_impact && (
                <div className="text-sm text-gray-600">
                  <span className="font-medium">Effects:</span> {addiction.lifestyle_impact}
                </div>
              )}
              
              {addiction.daily_cost !== undefined && addiction.daily_cost > 0 && (
                <div className="text-sm text-gray-600">
                  <span className="font-medium">Daily Cost:</span> ${addiction.daily_cost}
                </div>
              )}
            </div>
            
            {addiction.recommendations && addiction.recommendations.length > 0 && (
              <div className="mt-3 pt-3 border-t">
                <div className="text-sm font-medium text-gray-700 mb-2">Recommendations:</div>
                <ul className="text-xs text-gray-600 space-y-1">
                  {addiction.recommendations.slice(0, 3).map((rec, recIndex) => (
                    <li key={recIndex} className="flex items-start">
                      <span className="text-green-500 mr-1">•</span>
                      <span>{rec}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddictionImpact;
